import HelpDetail from '../loggedin/detail';

export default function PublicHelpDetail() {
  return <HelpDetail publicMode />;
}
